require('./button.js');
require('./dist/section-notice/ds6/section-notice.css');
